import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VueCookies from 'vue-cookies'

// ###################################
// REGISTRAZIONE COMPONENTI AGGIUNTIVI
// ###################################

// ##########################
// ### ICONE FONT AWESOME ###
// ##########################
// Import delle icone di FontAwesome. FontAwesome consiglia di importare solo
// le singole icone necessarie per poter contenere la grandezza finale della build.
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPiggyBank, faExclamationCircle, faInfoCircle, faKey, faCog, faListUl, faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'
import { faUniversity, faMoneyBillAlt, faFileInvoiceDollar, faCreditCard, faHandshake, faGift } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase, faStethoscope, faUtensils, faChartLine, faRegistered, faUserCog, faUser } from '@fortawesome/free-solid-svg-icons'
import { faPhoneSquareAlt, faMapMarkerAlt, faAt, faGlobe, faQrcode, faUserTie, faStoreAlt, faCoins } from '@fortawesome/free-solid-svg-icons'
import { faSave, faCheck, faPrint, faPaperPlane, faHistory, faEuroSign, faCloudUploadAlt, faPlus } from '@fortawesome/free-solid-svg-icons'
import { faHome, faCalendarAlt, faBook, faFileDownload, faMobileAlt, faCamera, faCheckDouble } from '@fortawesome/free-solid-svg-icons'
import { faGooglePlay, faApple } from '@fortawesome/free-brands-svg-icons'

Vue.config.productionTip = false

// Aggiungiamo le icone FontAwesome importate alla libreria
library.add( faPiggyBank, faExclamationCircle, faInfoCircle, faKey, faCog, faListUl, faHandHoldingUsd )
library.add( faUniversity, faMoneyBillAlt, faFileInvoiceDollar, faCreditCard, faHandshake )
library.add( faBriefcase, faStethoscope, faUtensils, faChartLine, faRegistered, faUserCog, faUser )
library.add( faPhoneSquareAlt, faMapMarkerAlt, faAt, faGlobe, faQrcode, faUserTie, faStoreAlt )
library.add( faSave, faCheck, faPrint, faPaperPlane, faHistory, faEuroSign, faCloudUploadAlt, faPlus )
library.add( faHome, faCalendarAlt, faBook, faFileDownload, faMobileAlt, faCamera, faCheckDouble )
library.add( faGooglePlay, faApple )
library.add( faGift, faCoins)

// Aggiungiamo globalmente il componente di font-awesome.
Vue.component('font-awesome-icon', FontAwesomeIcon)

// ###########################
// ### GESTIONE DEI COOKIE ###
// ###########################
// Registriamo il plugin per la gestione dei cookie
Vue.use(VueCookies)

// ############################################
// ### BOOSTRAP VUE E ICONE DI BOOSTRAP VUE ###
// ############################################
// Registriamo Bootstrap Vue e l'IconPlugin presso vue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// ##################################################################
// ### BOOSTRAP TYPEHEAD, PLUGIN PER CAMPO INPUT CON AUTOCOMPLETE ###
// ##################################################################
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

// ##################################################################
// ### FILTRI DI VUE PERSONALIZZATI PER IL RENDERING DEI TEMPLATE ###
// ##################################################################

// Formatta una stringa rappresentante una data nel nel formato italiano
Vue.filter('toitadate', function (value) {
  var m = moment( value );
  return m.format( 'DD-MM-YYYY' );
})

// Formatta una stringa rappresentante una data  con ora nel nel formato italiano
Vue.filter('toitadatetime', function (value) {
  var m = moment( value );
  return m.format( 'DD-MM-YYYY HH:mm:ss' );
})

// #####################################################################
// ### INTERCETTORI AXIOS SULLE CHIAMATE AL BACKEND E SULLE RISPOSTE ###
// #####################################################################
// Aggiungiamo un intercettore delle richieste nell'istanza
// globale di axios usata internamente dall'applicativo, in
// questo modo se lo user è loggato aggiungiamo alle sue
// richieste il token di autenticazione ed altri header di lavoro.
axios.interceptors.request.use(function (config) {

  // == TOKEN AUTENTICAZIONE ==
  // Se l'utente ha un token perchè è loggato allora
  // lo associo agli header delle richieste configuradolo
  // globalmente.
  if ( store.state.is_logged && store.state.token !== null ) {
    config.headers['Authorization'] = 'Token ' + store.state.token;
  }

  // == CUSTOMER PORTALE PERSONALIZZATO ==
  // Qualora settato aggiungiamo nel custom header "Customer" il nome
  // del customer attualmente in uso, in questo modo possiamo usarlo
  // al backend per capire se una richiesta proviene da un portale
  // personalizzato o meno.
  config.headers['Customer'] = undefined;
  if ( store.state.customer !== null ) {
    let customer = store.state.customer == 'default' ? 'Userportal' :
                                                        store.state.customer.charAt(0).toUpperCase() + store.state.customer.slice(1);
    config.headers['Customer'] = customer;
  }

  // == HEADER ACT-FOR PER REFERENTI AZIENDALI ==
  // Quando viene a loggarsi un utente di tipo referente aziendale viene settata
  // la variabile act_for nello store. La variabile viene di default
  // inizializzata con l'id ed il nome dell'azienda del referente, viene lasciata
  // "null" se chi si logga è un utente "semplice". Per tutte le viste che ricadono
  // sotto la root "backoffice-refazi" del router, dove sono ospitate
  // le pagine del referente aziendale, andiamo ad aggiungere l'header
  // "Act-For" con l'id settato nello store, per indicare al backend che
  // siamo difronte ad una vista di un referente aziendale il quale potrebbe
  // voler vedere i dati di un'altra azienda che non sia quella di sua
  // appartenenza. L'id di tale azienda è proprio quello settato nell'header.
  // Presa la route presente vediamo quindi che nell'array delle route matchate
  // ci sia quella che ha nome "backoffice-refazi" cioè la route della parte
  // di interfaccia dedicata al referente aziendale, se è così allora inviamo
  // backend l'header Act-For
  let is_refazi_root = router.currentRoute.matched.filter( ( elem ) => { return elem.name === 'backoffice-refazi' } ).length == 1;
  if ( is_refazi_root ){
    config.headers['Act-For'] = store.state.session_infos.act_for.id;
  }

  return config;

}, function (error) {
  return Promise.reject(error);
});

// Aggiungiamo un intercettore in tutte le risposte. In questo modo
// se la risposta è un 401 ( Unauthorized ) perchè non siamo autenticati
// o perchè il token è scaduto, allora effettuiamo il logout.
axios.interceptors.response.use(function (response) {
  // Questa funzione viene triggerata per tutte le risposte nel range 2xx.
  // Torniamo quindi semplicemente la risposta.
  return response;
}, function (error) {
  // Tutte le altre richieste invece passano da qui.
  // Intercettiamo le 401 ed eseguiamo il logout
  if ( error.response.status === 401 ) {
    // Solo la prima chiamata con 401 che trova l'utente ancora loggato
    // va ad eseguire il login, le altre anche se 401 procedono come consueto.
    if ( store.state.is_logged ) {
      // Prima di chiamare il logout il quale resetta il contenuto
      // dello store ci memeorizziamo il customer
      let customer = store.state.customer;

      // Chiamiamo quindi il logout e poi torniamo alla pagina di login
      // del customer corretto.
      store.dispatch( 'logout' );
      router.push( { name : 'login', params: { customer: customer } } );

      // Notifichiamo
      console.error( error.response.data.detail );
      alert( 'Sessione scaduta effettuare nuovamente il login.' );
    }
  } else {
    return Promise.reject(error);
  }
});


new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
